import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.akvofluo.com/api/', // URL base da API do Django
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;